import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'SdToggleMultiple'
})

export default class SdToggleMultiple extends Vue {
    @Prop() value!: any;
    @Prop() color?: boolean;
    @Prop() isNotNullable?: boolean;
    @Prop() labels?: object;
    @Prop() size?: string;
    @Prop() disabled!: boolean;

    get statusActive(): any {
        return this.value;
    }
    
    set statusActive(val: any) {
        this.$emit('input', val);
    }

    changeToggleMultiple(status: number): void {
        if (this.disabled) { return; }

        if (this.isNotNullable) {
          this.$emit('input', !this.value);
          this.$emit('click');
          return;
        }
                
        const newStatus = this.statusActive === status ? null : status;
        this.statusActive = newStatus;
        this.$emit('click');
      }
}
